"use strict";
/*!
 * parallax.js add on by Dan Hendrickson
 * @license MIT (https://github.com/pixelcog/parallax.js/blob/master/LICENSE)
 * By default, parallax.js does not support overlaying content on top of the parallax image.
 * This script adds that functionality. Withing the parallax image container, add a div with the class "parallax-overlay".
 * When parallax.js is initialized, it will look for this div and move it to the relative ".parallax-slider" div that is
 * prepended to the body. This will allow the overlay to be displayed on top of the parallax image.
 */
/**
 * Apply parallax overlay to parallax sections
 */
const applyParallaxOverlay = () => {
    var parallaxSections = document.querySelectorAll('[data-image-src]');
    // Loop through each parallax section
    parallaxSections.forEach(function (section) {
        // Isolate the overlay and css classes
        var overlay = section.querySelector('.parallax-overlay');
        var cssClasses = section.getAttribute('data-parallax-classes');
        // If overlay exists, find the matching parallax slider
        if (overlay) {
            // Find all parallax sliders
            var parallaxSliders = document.querySelectorAll('.parallax-slider');
            parallaxSliders.forEach(function (slider) {
                // If the slider has the same image source as the section, append the overlay
                if (slider.getAttribute('src') === section.getAttribute('data-image-src')) {
                    var parent = slider.parentElement;
                    parent.appendChild(overlay);
                    if (cssClasses) {
                        parent.classList.add(...cssClasses.split(' '));
                    }
                }
            });
        }
    });
};
/**
 * Check if Parallax.js has been initialized
 * @returns {boolean} True if Parallax.js has been initialized
 */
function checkParallaxInitialized() {
    const elements = document.querySelectorAll('.parallax-mirror');
    let initialized = elements.length > 0;
    if (initialized) {
        console.log('Parallax.js has been initialized');
    }
    return initialized;
}
/**
 * MutationObserver to detect when Parallax.js has been initialized
 */
const observer = new MutationObserver(() => {
    if (checkParallaxInitialized()) {
        console.log("Parallax.js initialized dynamically.");
        applyParallaxOverlay();
        observer.disconnect(); // Stop observing once detected
    }
});
/**
 * Observe the body for changes
 */
observer.observe(document.body, { childList: true, subtree: true });
